import { IProductLightModel } from "@app/products/products.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const lightAdapter: EntityAdapter<IProductLightModel> = createEntityAdapter<IProductLightModel>({
	selectId: product => product.sku
});